module.exports = __webpack_public_path__ + "img/uom.1ed607a7.png";